<template>
	<JBox class="s-w-full">
		<!-- Content -->
		<JBox :style="`padding-left: ${layer * layerPadding}px`">
			<slot :item="node" />
		</JBox>

		<!-- Children -->
		<JBox class="s-w-full" v-if="node.children && node.isExpanded !== false">
			<CTreeNode
				v-for="node in node.children"
				:node="node"
				:key="node.id"
				:layer="layer + 1"
				v-on="$listeners"
				:layerPadding="layerPadding"
			>
				<template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
					<slot :name="slot" v-bind="scope" />
				</template>
			</CTreeNode>
		</JBox>
	</JBox>
</template>

<script>
export default {
	name: "CTreeNode",

	props: {
		node: {
			type: Object,
			default: () => ({})
		},

		layer: {
			type: Number,
			default: 0
		},

		layerPadding: {
			type: Number
		}
	}
}
</script>
